<template>
  <div class="deliveryRecord p-4 space-y-4">
    <viewTitle
        title="业务管理 / 预约记录管理 / 预约送货记录"
        :showReturn="true"
    >
      <template slot="return">
        <el-button
            v-has="['c-booking-delivery-export']"
            @click="onExport"
            size="small"
            type="primary"
        >导出
        </el-button
        >
      </template>
    </viewTitle>
    <el-radio-group @change="onSearch" v-model="state" size="small">
      <el-radio-button
          v-for="item in stateList"
          :key="item.value"
          :label="item.value"
      >{{ item.label }}（{{
          countMap[`state_${item.value}`] || 0
        }}）
      </el-radio-button
      >
      <el-radio-button label
      >全部({{ countMap[`total`] || 0 }})
      </el-radio-button
      >
    </el-radio-group>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="预约单号">
        <el-input
            clearable
            v-model="queryParam.booking_code"
            placeholder="请输入预约单号"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
            clearable
            v-model="queryParam.order_code"
            placeholder="请输入订单号"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-input
            clearable
            v-model="queryParam.supplier_name"
            placeholder="请输入供应商名称"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商编号">
        <el-input
            clearable
            v-model="queryParam.supplier_code"
            placeholder="请输入供应商编号"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="磅单号">
        <el-input
            clearable
            v-model="queryParam.pound_code"
            placeholder="请输入磅单号"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="预约业务名称">
        <el-select
            clearable
            v-model="queryParam.business_id"
            placeholder="请选择"
        >
          <el-option
              v-for="item in business"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆业务类型">
        <el-select
            clearable
            v-model="queryParam.car_business_id"
            placeholder="请选择"
        >
          <el-option
              v-for="item in car_business"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆类型">
        <el-select
            class="w-60"
            clearable
            v-model="queryParam.vehicle_type"
            placeholder="请选择车辆类型"
        >
          <el-option
              v-for="car in vehicleTypes"
              :key="car.id"
              :label="car.name"
              :value="car.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料类型">
        <el-input
            clearable
            v-model="queryParam.chip_type"
            placeholder="请输入物料类型"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
            clearable
            v-model="queryParam.license_plate"
            placeholder="请输入车牌号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="timeRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="预约时间">
        <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="queryParam.booking_day"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyyMMdd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="集装箱号">
        <el-input
            clearable
            v-model="queryParam.container_number"
            placeholder="请输入集装箱号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="逗留超时车辆">
        <el-select
            class="w-42"
            clearable
            v-model="queryParam.stranded_state"
            placeholder="请选择逗留超时车辆"
        >
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登记时间">
        <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="registerTimeRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small"
        >刷新数据
        </el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
        class="mt-4"
        :isIndex="false"
        :isSelection="false"
        :selection.sync="rowKeySelection"
        :data="dataSource"
        :columns="columns"
        :query.sync="pagintion"
        :total="total"
        row-key="booking_id"
        @loadPage="loadData"
    >
      <template slot="business_list" slot-scope="{ row }">
        <div v-for="item in row.business_list" :key="item.id">
          {{ item.name }}
        </div>
      </template>
      <template slot="name" slot-scope="{ row }">
        <div>{{ row.name }}</div>
        <div>({{ row.contact }})</div>
      </template>
      <template slot="create_time" slot-scope="{ row }">{{
          row.create_time | timeFormat
        }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link
              v-if="row.booking_state == 0"
              @click="onOutWard(row)"
              v-has="['c-booking-delivery-outward']"
              type="primary"
              label="出车"
          ></c-link>
          <c-link
              v-if="row.booking_state == 41"
              @click="onAuth(row)"
              type="primary"
              v-has="['c-booking-delivery-auth']"
              label="授权"
          ></c-link>
          <c-link
              v-if="row.booking_state == 42"
              @click="onCalling(row)"
              type="primary"
              v-has="['c-booking-delivery-calling']"
              label="叫号"
          ></c-link>
          <c-link
              v-if="
              [43, 44, 45, 49].includes(row.booking_state) &&
                ['CD', 'NB'].includes(row.order_type)
            "
              @click="onEditWarehouse(row)"
              type="primary"
              v-has="['c-booking-delivery-updateWare']"
              label="修改"
          ></c-link>
          <c-link
              @click="onView(row)"
              v-has="['c-booking-delivery-detail']"
              type="primary"
              label="查看"
          ></c-link>
          <template v-if="row.booking_state == 43">
            <template v-if="canManualEnter(row)">
              <c-link
                  @click="onReleaseEnter(row)"
                  type="primary"
                  v-has="['c-booking-delivery-into']"
                  label="放行进厂"
              ></c-link>
            </template>
            <template v-else-if="needSendCard(row)">
              <c-link
                  @click="onSendCard(row)"
                  type="primary"
                  v-has="['c-booking-delivery-send']"
                  label="发卡"
              ></c-link>
            </template>
          </template>
          <c-link
              @click="onTaskSampleConfirm(row)"
              v-if="row.booking_state == 44 && row.sub_state == 41"
              type="primary"
              v-has="['c-booking-delivery-sampling']"
              label="取样确认"
          ></c-link>
          <c-link
              @click="onPrioritize(row)"
              type="primary"
              v-if="checkPrioritize(row)"
              v-has="['c-booking-delivery-priority']"
              label="优先处理"
          ></c-link>
          <c-link
              v-if="row.booking_state == 44 && row.sub_state == 42"
              @click="onTaskSampleConfirm(row)"
              type="primary"
              v-has="['c-booking-delivery-addSampling']"
              label="加抽确认"
          ></c-link>
          <c-link
              v-if="showBeginUnloadAction(row)"
              type="primary"
              label="外观确认"
              @click="onUnload(row, 1)"
              v-has="['c-booking-delivery-unload']"
          ></c-link>
          <c-link
              v-if="showCompleteUnloadAction(row)"
              type="primary"
              label="结束装卸"
              @click="onUnload(row, 2)"
              v-has="['c-booking-delivery-finish']"
          ></c-link>
          <template v-if="[44, 45, 49].includes(row.booking_state)">
            <c-link
                v-has="['c-booking-delivery-change']"
                @click="onEditOrder(row)"
                type="primary"
                label="修改物料"
            ></c-link>
          </template>
          <c-link
              v-if="row.booking_state == 49 && row.order_type === 'IB'"
              v-has="['c-booking-delivery-microwave']"
              @click="onFinishMicrowave(row)"
              type="primary"
              label="测水完成"
          ></c-link>
          <template v-if="row.booking_state == 46">
            <template v-if="canManualLeave(row)">
              <c-link
                  v-has="['c-booking-delivery-out']"
                  @click="onReleaseLeave(row, true)"
                  type="primary"
                  label="出厂"
              ></c-link>
            </template>
            <template v-else-if="needReturnCard(row)">
              <c-link
                  @click="onReturnCard(row)"
                  type="primary"
                  v-has="['c-booking-delivery-return']"
                  label="退卡"
              ></c-link>
            </template>
          </template>
        </div>
      </template>
    </c-table>
    <outward ref="outward" @ok="refreshListAndCount"/>
    <loadAnUnload ref="loadAnUnload" @ok="refreshListAndCount"/>
    <editWarehouse ref="editWarehouse" @ok="refreshListAndCount"/>
    <AccessCardModal
        send-url="/api/queue/admin/delivery_send_card"
        return-url="/api/queue/admin/delivery_return_card"
        :showDoor="true"
        ref="accessCard"
        @ok="refreshListAndCount"
    />
    <editOrder ref="editOrder" @ok="refreshListAndCount"/>
    <prioritizeModal ref="prioritizeModal" @ok="refreshListAndCount"/>
    <finishMicrowaveModal ref="finishMicrowaveModal" @ok="refreshListAndCount"/>
  </div>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import outward from "./components/outward.vue";
import editWarehouse from "./components/editWarehouse.vue";
import loadAnUnload from "./components/loadAnUnload.vue";
import AccessCardModal from "../AccessCard/components/AccessCardModal.vue";
import prioritizeModal from "./components/prioritizeModal.vue";
import editOrder from "./components/editOrder.vue";
import finishMicrowaveModal from "./components/finishMicrowaveModal.vue";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      // 日期选择器配置（统一管理）
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },


      timeRange: [
        moment()
            .subtract(1, "month")
            .startOf("day")
            .valueOf(),
        moment()
            .endOf("day")
            .valueOf()
      ],
      // 新增：登记时间范围
      registerTimeRange: [],
      queryParam: {
        begin_time: moment()
            .subtract(1, "month")
            .startOf("day")
            .unix(),
        end_time: moment()
            .endOf("day")
            .unix(),
        // 新增：登记时间查询参数
        register_begin_time: "",
        register_end_time: "",
        booking_code: "",
        order_code: "",
        supplier_name: "",
        supplier_code: "",
        pound_code: "",
        business_id: "",
        car_business_id: "",
        vehicle_type: "",
        chip_type: "",
        license_plate: "",
        booking_day: "",
        container_number: "",
        stranded_state: ""
      },
      countMap: {},
      state: "",
      columns: [
        {width: 150, label: "预约号", prop: "code"},
        {label: "供应商名称", prop: "supplier_name"},
        {label: "供应商编号", prop: "supplier_code"},
        {label: "预约业务名称", prop: "business_name"},
        {label: "车辆业务类型", prop: "business_list"},
        {label: "订单号", prop: "order_code"},
        {width: 160, label: "申请时间", prop: "create_time"},
        {label: "车牌号", prop: "license_plate"},
        {label: "司机", prop: "name"},
        {
          label: "预约状态",
          prop: "booking_state",
          formatData: row => {
            return this.businessState[row.booking_state] || "--";
          }
        },
        {
          label: "预约日期",
          prop: "booking_day",
          formatData: row => {
            return row.booking_day
                ? moment(row.booking_day, "YYYYMMDD").format("YYYY-MM-DD")
                : "--";
          }
        },
        {
          label: "预约时间段",
          prop: "booking_time",
          formatData: row => {
            return `${row.begin_time} ~ ${row.end_time}`;
          }
        },
        {label: "装卸点", prop: "warehouse_name"},
        {label: "操作", prop: "action"}
      ],
      stateList: [
        {label: "待出车", value: "0"},
        {label: "待登记", value: "1"},
        {label: "待授权", value: "41"},
        {label: "待叫号", value: "42"},
        {label: "待进厂", value: "43"},
        {label: "待入厂磅", value: "48"},
        {label: "待测水", value: "49"},
        {label: "待取样", value: "44"},
        {label: "待装卸", value: "45"},
        {label: "待出厂", value: "46"},
        {label: "已完成", value: "8"},
        {label: "已过号", value: "47"},
        {label: "已关闭", value: "7"}
      ],
      business: [],
      // 显式维护送货业务类型常量，避免查询条件误加载提货业务。
      deliveryBusinessType: 11,
      allCarBusiness: [],
      car_business: [],
      // 关闭 mixin 默认首屏加载，改由页面在初始化完成后显式触发一次查询。
      disabledCreated: true,
      // 关闭查询条件修改后的自动查询，避免慢查询在输入和筛选过程中被频繁触发。
      autoSearch: false,
      // 导出数据方法 - 修复：添加登记时间参数
      exportDataEvent: params => {
        const {
          booking_day,
          begin_time,
          end_time,
          register_begin_time,
          register_end_time,
          ...data
        } = params;

        return this.$common.http({
          url: "/api/queue/admin/export_booking_record1",
          data: {
            ...data,
            state: this.state,
            create_begin_time: begin_time,
            create_end_time: end_time,
            booking_day_begin_time: booking_day ? booking_day[0] : "",
            booking_day_end_time: booking_day ? booking_day[1] : "",
            // 传递登记时间参数
            register_begin_time: register_begin_time,
            register_end_time: register_end_time
          },
          noLoading: true
        });
      },
      // 查询数据方法 - 修复：正确获取登记时间参数
      fetchDataEvent: params => {
        const {
          booking_day,
          begin_time,
          end_time,
          register_begin_time,
          register_end_time,
          ...data
        } = params;

        return this.$common.http({
          url: "/api/queue/admin/query_booking_record1",
          data: {
            ...data,
            state: this.state,
            create_begin_time: begin_time,
            create_end_time: end_time,
            booking_day_begin_time: booking_day ? booking_day[0] : "",
            booking_day_end_time: booking_day ? booking_day[1] : "",
            // 修复：从params中获取登记时间参数
            register_begin_time: register_begin_time,
            register_end_time: register_end_time
          }
        });
      }
    };
  },
  computed: {
    ...mapGetters(["businessState", "vehicleTypes"])
  },
  components: {
    outward,
    editWarehouse,
    loadAnUnload,
    AccessCardModal,
    editOrder,
    prioritizeModal,
    finishMicrowaveModal
  },
  mixins: [initListMinxin, mixinTableLyout],
  // 修复：添加时间范围监听
  watch: {
    // 监听申请时间变化
    timeRange: {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          this.queryParam.begin_time = Math.floor(newVal[0] / 1000);
          this.queryParam.end_time = Math.floor(newVal[1] / 1000);
        } else {
          // 默认时间范围：近一个月
          this.queryParam.begin_time = moment()
              .subtract(1, "month")
              .startOf("day")
              .unix();
          this.queryParam.end_time = moment()
              .endOf("day")
              .unix();
        }
      },
      deep: true,
      immediate: true
    },
    // 监听登记时间变化
    registerTimeRange: {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          // 转换为unix时间戳（秒）
          this.queryParam.register_begin_time = Math.floor(newVal[0] / 1000);
          this.queryParam.register_end_time = Math.floor(newVal[1] / 1000);
        } else {
          this.queryParam.register_begin_time = "";
          this.queryParam.register_end_time = "";
        }
      },
      deep: true,
      immediate: true
    },
    // 监听预约业务变化，联动车辆业务类型下拉选项
    'queryParam.business_id': {
      handler() {
        this.syncCarBusinessOptionsByBusiness();
      }
    }
  },
  methods: {
    // 进厂门岗通行模式：0兼容旧逻辑 1过磅对 2卡对。
    getInPassMode(row) {
      return Number(row.in_pass_mode || 0);
    },
    // 出厂门岗通行模式：0兼容旧逻辑 1过磅对 2卡对。
    getOutPassMode(row) {
      return Number(row.out_pass_mode || 0);
    },
    // 仅 CARD_PAIR 显示发卡；LEGACY 保持原有“非CD发卡”逻辑。
    needSendCard(row) {
      const passMode = this.getInPassMode(row);
      if (passMode === 2) {
        return true;
      }
      if (passMode === 1) {
        return false;
      }
      return row.order_type !== "CD";
    },
    // 仅 CARD_PAIR 显示退卡；LEGACY 保持原有“非CD退卡”逻辑。
    needReturnCard(row) {
      const passMode = this.getOutPassMode(row);
      if (passMode === 2) {
        return true;
      }
      if (passMode === 1) {
        return false;
      }
      return row.order_type !== "CD";
    },
    // 兼容旧业务：仅 LEGACY + CD 继续保留手动放行进厂。
    canManualEnter(row) {
      return this.getInPassMode(row) === 0 && row.order_type === "CD";
    },
    // 兼容旧业务：仅 LEGACY + CD 继续保留手动放行出厂。
    canManualLeave(row) {
      return this.getOutPassMode(row) === 0 && row.order_type === "CD";
    },
    // 化辅取消外观确认后，不再给 NB 展示该入口；其他业务仍沿用待卸货且未开始装卸的旧规则。
    showBeginUnloadAction(row) {
      return row.booking_state == 45 && !row.unload_begin_time && row.order_type !== "NB";
    },
    // 关键步骤：PC 列表按钮直接复用后端返回的 can_complete_unload，避免前端再猜测“待取样是否可直接完成卸货”。
    showCompleteUnloadAction(row) {
      return Number(row.can_complete_unload) === 1;
    },
    // 校验是否需要优先处理
    checkPrioritize(row) {
      let status = false;
      const {booking_state, queue} = row;
      if (booking_state == 44 || booking_state == 45) {
        if (queue && queue.is_priority == 0) {
          status = true;
        }
      }
      return status;
    },
    // 优先处理
    onPrioritize(row) {
      this.$refs.prioritizeModal.onOpen(row.booking_id);
    },
    // 发卡
    onSendCard(row) {
      this.$refs.accessCard.onOpen(row.booking_id, 1);
    },
    // 退卡
    onReturnCard(row) {
      this.$refs.accessCard.onOpen(row.booking_id, 2);
    },
    // 根据预约业务同步车辆业务类型选项，避免出现无效筛选组合
    syncCarBusinessOptionsByBusiness() {
      if (!this.allCarBusiness.length) {
        return;
      }

      const businessId = this.queryParam.business_id;
      const nextOptions = businessId
          ? this.allCarBusiness.filter(item => item.pid === businessId)
          : [...this.allCarBusiness];

      this.car_business = nextOptions;

      if (
          this.queryParam.car_business_id &&
          !nextOptions.some(item => item.id === this.queryParam.car_business_id)
      ) {
        this.queryParam.car_business_id = "";
      }
    },
    // 从路由参数初始化查询条件，并在业务数据加载后复用同一套联动逻辑
    initQueryParamFromRoute() {
      const {query} = this.$route;
      Object.keys(query).forEach(key => {
        if (this.queryParam.hasOwnProperty(key)) {
          this.$set(this.queryParam, key, query[key]);
        }
      });
    },
    // 加载送货预约业务与送货车辆业务类型数据，并缓存全量子业务用于前端联动
    async getBusiness() {
      const [businessResponse, carBusinessResponse] = await Promise.all([
        this.$common.http({
          url: "/api/queue/admin/query_business",
          data: {
            // 关键步骤：预约送货记录页只展示送货业务，避免把提货业务一起带入查询条件。
            state: 0,
            keyword: "",
            type: this.deliveryBusinessType,
            is_parent: 0,
            page_size: 999
          }
        }),
        this.$common.http({
          url: "/api/queue/admin/query_business",
          data: {
            // 关键步骤：车辆业务类型同样按送货业务口径过滤，保持父子下拉口径一致。
            state: 0,
            keyword: "",
            type: this.deliveryBusinessType,
            is_parent: 1,
            page_size: 999
          }
        })
      ]);

      // 先缓存送货子业务全集，再复用既有联动逻辑按父业务过滤展示项。
      this.business = businessResponse.data.data.data;
      this.allCarBusiness = carBusinessResponse.data.data.data;
      this.syncCarBusinessOptionsByBusiness();
    },
    // 显式刷新页签统计，避免列表分页、排序、刷新都重复触发 count 接口。
    refreshCount() {
      this.$common
          .http({
            url: "/api/queue/admin/count_booking_record1",
            noLoading: true
          })
          .then(res => {
            const total = Object.values(res.data.data).reduce((a, b) => a + b);
            this.countMap = {...res.data.data, total: total};
          });
    },
    // 统一刷新列表和统计，供状态变更成功后复用。
    refreshListAndCount() {
      this.refreshData();
      this.refreshCount();
    },
    onView(row) {
      this.$router.push({
        path: `/rhqy/service/AppointDeliveryRecord/Detail/${row.booking_info_id}`
      });
    },
    // 出车
    onOutWard(row) {
      this.$refs.outward.onOpen(row.booking_id);
    },
    // 授权
    onAuth(row) {
      this.$confirm("确认业务授权吗？", "授权确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/auth_booking",
            data: {
              booking_ids: row.booking_id
            }
          });
          this.refreshListAndCount();
        } catch (error) {
          this.$message.error("授权失败：" + (error.message || "系统异常"));
        }
      });
    },
    // 叫号
    onCalling(row) {
      this.$confirm("确认业务确认叫号吗？", "叫号确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/special_call_booking",
            data: {
              booking_ids: row.booking_id
            }
          });
          this.refreshListAndCount();
        } catch (error) {
          this.$message.error("叫号失败：" + (error.message || "系统异常"));
        }
      });
    },
    // 修改装卸点
    onEditWarehouse(row) {
      this.$refs.editWarehouse.onOpen(
          row.booking_info_id,
          row.booking_state === 45
      );
    },
    // 放行进厂
    onReleaseEnter(row) {
      this.$confirm("确认进行进厂操作吗？", "进厂确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/into_base",
            data: {
              booking_id: row.booking_id
            }
          });
          this.refreshListAndCount();
        } catch (error) {
          this.$message.error("进厂操作失败：" + (error.message || "系统异常"));
        }
      });
    },
    // 放行离厂
    onReleaseLeave(row) {
      this.$confirm("确认进行出厂操作吗？", "出厂确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/out_base",
            data: {
              booking_id: row.booking_id
            }
          });
          this.refreshListAndCount();
        } catch (error) {
          this.$message.error("出厂操作失败：" + (error.message || "系统异常"));
        }
      });
    },
    // 取样确认
    onTaskSampleConfirm(row) {
      const isSample = row.sub_state == 41;
      this.$confirm(
          `确认进行${isSample ? "取样完成" : "取样加抽"}操作吗？`,
          `${isSample ? "取样确认" : "加抽确认"}`
      ).then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/dispatcher/save_sampling",
            data: {
              booking_id: row.booking_id,
              remark: "",
              sampling_type: isSample ? 1 : 2
            }
          });
          this.refreshListAndCount();
        } catch (error) {
          this.$message.error(`${isSample ? "取样" : "加抽"}失败：` + (error.message || "系统异常"));
        }
      });
    },
    // 外观确认
    onStartUnload(row) {
      this.$confirm("确认完成外观确认吗？", "外观确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/dispatcher/begin_unload",
            data: {
              booking_id: row.booking_id,
              check: 1
            }
          });
          this.refreshListAndCount();
        } catch (error) {
          this.$message.error("外观确认失败：" + (error.message || "系统异常"));
        }
      });
    },
    // 结束装卸
    onUnload(row, type) {
      this.$refs.loadAnUnload.onOpen(row, type);
    },
    // 修改物料
    onEditOrder(row) {
      this.$refs.editOrder.onOpen(row);
    },
    // 国废待测水状态允许人工补录完成，作为 SAP 回调异常时的兜底入口。
    onFinishMicrowave(row) {
      this.$refs.finishMicrowaveModal.onOpen(row.booking_id);
    },
    // 重置筛选条件
    onReset() {
      // 重置时间选择器
      this.timeRange = [
        moment().subtract(1, "month").startOf("day").valueOf(),
        moment().endOf("day").valueOf()
      ];
      this.registerTimeRange = [];

      // 重置查询参数
      this.queryParam = {
        begin_time: moment().subtract(1, "month").startOf("day").unix(),
        end_time: moment().endOf("day").unix(),
        register_begin_time: "",
        register_end_time: "",
        booking_code: "",
        order_code: "",
        supplier_name: "",
        supplier_code: "",
        pound_code: "",
        business_id: "",
        car_business_id: "",
        vehicle_type: "",
        chip_type: "",
        license_plate: "",
        booking_day: "",
        container_number: "",
        stranded_state: ""
      };
      this.syncCarBusinessOptionsByBusiness();

      // 重置状态筛选
      this.state = "";

      // 调用mixins中的重置方法
      if (this.$options.mixins && this.$options.mixins.length) {
        const initMixin = this.$options.mixins.find(mixin => mixin.methods && mixin.methods.onReset);
        if (initMixin && initMixin.methods.onReset) {
          initMixin.methods.onReset.call(this);
        }
      }

      // 刷新数据
      this.refreshListAndCount();
    }
  },
  created() {
    // 先回填路由查询条件，再在业务数据加载完成后同步联动子业务选项
    this.initQueryParamFromRoute();
    this.getBusiness();
    this.refreshCount();

    // 关键步骤：页面首次进入时仍需主动查询一次，但后续修改筛选条件不再自动触发查询。
    this.$nextTick(() => {
      this.refreshData();
    });
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common";

// 优化表单布局
.search-form-inline {
  .el-form-item {
    margin-bottom: 15px;
  }
}

// 表格操作列样式优化
.space-x-4 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
